<template>
    <div class="module" data-notice="数据是远程拿师讯人才应用的数据">
        <div class="inner paddingH16">

            <header class="header moduleHeader clearfix" style="padding-top: 16px;">
                <div class="floatL">
                    <div class="titleArea font20r bold">{{ title }}</div>
                </div>
                <div class="fr alignRight">
                    <i class="icon moreContentIcon" @click="goToRc()"></i>
                </div>
            </header>

            <div class="body" style="padding-bottom: 12px;">
                <div class="organizationList">
                    <div class="organizationItem marginB8 paddingT16" style="line-height: 32px;"
                         v-for="dataItem in dataList" :key="dataItem.id" @click="viewItem(dataItem)">
                        <div class="marginB16 clearfix" style="line-height: 1.4em;">
                            <img class="size48 circle cover fl" :src="dataItem.headImage"/>
                            <div class="marginL8 fl" >
                                <router-link class="font14r grey20 bold" :to="'/parkDetail/' + dataItem.parkId">{{ dataItem.name }}
                                </router-link><br/>
                                <i class="icon greyLocationIcon alignM" style="width: 16px; height: 16px;"></i>
                                <span class="font12r grey">
                                    {{ dataItem ? dataItem.province : '' }}
                                    {{ dataItem ? dataItem.city : '' }}
                                    {{ dataItem ? dataItem.area : '' }}
                                    {{ dataItem ? dataItem.address : '未知位置' }}
                                </span>
                            </div>
                            <div class="fr font14r red bold">
                                <span>
                                    {{ dataItem ? dataItem.salaryMin || "面议" : "面议" }}<span v-if="dataItem.salaryMin">千</span>
                                </span>
                                <span v-if="dataItem.salaryMax && dataItem.salaryMin">&nbsp;-&nbsp;{{
                                    dataItem ? dataItem.salaryMax || "面议" : "面议" }}
                                    <span v-if="dataItem.salaryMax">千</span>
                                </span>
                                <span v-if="dataItem.salaryMin && dataItem.salaryMax">/月</span>
                            </div>
                        </div>
                        <div class="grey20 clearfix font14r">
                            <span class="marginR4 bold">在招职位：</span>
                            <div class="jobList inline">
                                  <span class="textLabel" style="margin: 0 4px;"
                                        v-for="(jobItem, i) in dataItem.jobList.length > 3 ?
                                                [dataItem.jobList[0],dataItem.jobList[1],dataItem.jobList[2]] : dataItem.jobList"
                                        :key="i" :data-id="jobItem.id">
                                    {{ jobItem.name }}
                                  </span>
<!--                                <span class="textLabel" v-if="dataItem.jobList.length > 5"-->
<!--                                      style="margin: 0 4px;">...</span>-->
                                <span v-show="dataItem.jobList.length < 1">暂无</span>
                            </div>
                        </div>
                        <div class="descArea bgFAFAFA roundBorder4 font13r"
                             style="padding: 9px 0 12px 7px; line-height: 19px; color: hsla(219, 16%, 60%, 1);">
                            <div style="overflow: hidden">
                                <div>
                                    简介：{{
                                        69 >= dataItem.introduce.length ? dataItem.introduce : dataItem.introduce.substr(0, 69) + '...'
                                    }}
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- end .organizationItem -->
                </div>
                <!-- end .organizationList -->
            </div>
        </div>

    </div><!-- end .module -->
</template>

<script>
import modulePart from '@comp/part/modulePart';

// config
import appConfig from '@/appConfig';
import externalApp from '@/data/externalApp';

// util
import numberHelper from "@/util/numberHelper";
import arrayHelper from "@/util/arrayHelper";
import appHelper from "@util/appHelper";

const config = {
    apiConfig: {
        list: {
            // externalApp.rcWebApp.apiBaseUrl +
            url: "agency",
            params : {
                url : externalApp.rcWebApp.apiBaseUrl + 'portal/recruit/park/list?limit=1',
                method : 'GET'
            },
            pageName : null,
            dataPath: "data.records",
            totalPagePath: "data.pages"
        }
    },
    demoTitleList: [
        '园长“苦恼”，幼儿园之间到底在竞争什么',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: "parkListModule",
    extends: modulePart,
    props: {
        title: {
            type: String,
            default: '模块标题'
        }
    },
    data() {
        return {
            apiConfig: config.apiConfig,
            pageSize : 1,
            enableDataList : true,
            autoLoadDataList : true,

            scrollToLoadNextPage : false
        }
    },
    methods : {
        goToRc() {
            let url = externalApp.rcWebApp.url;
            appHelper.redirect(url);
        },
        viewItem (dataItem) {
            let url = externalApp.rcWebApp.url + '#/parkDetail/' + dataItem.parkId;
            appHelper.redirect(url);
        },
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: #FF3D38;
}
.grey {
    color: #8994A9;
}
.moreContentIcon {
    width: 72px;
    height: 20px;
    background-image: url('data:image/png;base64,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');
}
.organizationList {
    .jobList {
        .textLabel {
            height: 22px;
            line-height: 22px;
            padding: 0 8px;
            border-radius: 4px;
            font-size: 12px;
            border: solid 1px hsla(36, 100%, 57%, 1);
            background: transparent;
            color: hsla(36, 100%, 57%, 1);
        }
    }

}
</style>
